<template>
  <v-autocomplete
    v-model="selectedItem"
    :items="sortedItems"
    :search-input.sync="search"
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled"
    :rules="rules"
    :readonly="!!selectedItem && !!selectedItem.id"
    chips
    item-text="name"
    item-value="email"
    return-object
    no-filter
    clearable
  >
    <template slot="no-data">
      <v-list-tile>
        <v-list-tile-title>No Employees found </v-list-tile-title>
      </v-list-tile>
    </template>
    <template
      slot="selection"
      slot-scope="{item, selected}"
    >
      <v-chip :selected="selected">
        <span v-text="item.name" />
      </v-chip>
    </template>
    <template
      slot="item"
      slot-scope="{ item }"
    >
      <v-list-tile-content>
        <v-list-tile-title v-text="item.name" />
        <v-list-tile-sub-title v-text="item.email" />
      </v-list-tile-content>
    </template>
  </v-autocomplete>
</template>
<script>
import _sortBy from 'lodash/sortBy';
import _capitalize from 'lodash/capitalize';

export default {
  name: 'VizmoAutoComplete',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    items: {
      type: Array,
      default: () => [],
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedItem: {},
      sortedItems: [],
      originItems: [],
      search: ''
    };
  },
  watch: {
    items: {
      handler(val) {
        if (!val && val.length === 0) return;
        const items = val;
        const formattedItems = items.map(item => ({
          name: item.name,
          email: item.email,
          id: item.id,
          phone: item.phone,
          designation: item.designation || ''
        }));
        this.sortedItems = _sortBy(formattedItems, ['name']);
        this.originItems = this.sortedItems;
      },
      immediate: true
    },
    value: {
      handler(val) {
        if (!val) return;
        this.selectedItem = val;
      },
      immediate: true
    },
    selectedItem: {
      handler(val) {
        if (!val) return;
        this.$emit('change', val);
      }
    },
    search: {
      handler(val) {
        if (val) {
          const items = this.originItems;
          const filtered = items.filter(o =>
            o.name.toLowerCase().includes(val.toLowerCase())
          );
          this.sortedItems = _sortBy(filtered, [o => o.name.indexOf(val)]);
        }
      }
    }
  },
  methods: {
    toCapitalize(String) {
      return _capitalize(String);
    }
  }
};
</script>

